import { classNames } from "utilities/classNames";
import styles from "./styles.module.scss";

const Badge: React.FC = ({ children }) => {
  return <span className={classNames(styles.badge, "p-3")}>{children}</span>;
};

export default Badge;
